export const IDGThankYou = () => {
    return (
        <section className="section">
            <div className="container">
                <h2>Thank you!</h2>
                <p className="lead">
                    Your Informed Discussion Guide has been submitted.
                </p>
            </div>
        </section>
    );
};
